
<script>
    import Vue from 'vue';

    const eventBus = new Vue({});

    window.eventBus = eventBus;

    export default eventBus;

</script>
